import { render, staticRenderFns } from "./CreditNoteGroup.vue?vue&type=template&id=398f0b0c&scoped=true"
import script from "./CreditNoteGroup.vue?vue&type=script&lang=js"
export * from "./CreditNoteGroup.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteGroup.vue?vue&type=style&index=0&id=398f0b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f0b0c",
  null
  
)

export default component.exports